import { call, put, select } from 'redux-saga/effects';
import { integrationsModel } from '../../..';
import { logger } from '../../../../../../shared/lib';
import { integrationsApi } from '../../../../../../shared/api';
import { teamsModel } from '../../../../../../features/teams';
import {
  createNotification,
  snackbarModel,
} from '../../../../../../features/snackbar';

export function* updateSalesforceSettings({
  payload: { data, cb },
}: ReturnType<typeof integrationsModel.actions.updateSalesforceSettings>) {
  yield put(integrationsModel.actions.setIsUpdatingSalesforceSettings(true));

  const { id: teamId } = yield select(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  try {
    yield call(integrationsApi.updateSalesforceSettings, {
      teamId,
      settings: data,
    });

    yield call(teamsModel.sagas.refreshTeamsData);

    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification(
          'success',
          'Successfully updated Salesforce settings'
        )
      )
    );
    cb();
  } catch (error) {
    logger.error(error);

    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('error', 'Failed to update Salesforce settings')
      )
    );
  } finally {
    yield put(integrationsModel.actions.setIsUpdatingSalesforceSettings(false));
  }
}
